<template>
  <tw-card class="p-4 bg-amber-50">
    <div>
      <h4>Add a new reply:</h4>
      <tw-wysiwyg v-if="!LoadingSendingSupportRequestMessage" ref="editor" v-model="SupportRequestMessageContents" class="mb-2" />
      <div class="mt-2">
        <tw-button class="float-right" :loading="LoadingSendingSupportRequestMessage" :disabled="LoadingSendingSupportRequestMessage || !SupportRequestMessageContents" variant="primary" @click="sendSupportRequestMessage">
          <icon icon="reply" /> Send message
        </tw-button>
        <tw-upload-field variant="warning" root multiple @uploaded="uploaded">
          Attach files to reply...
        </tw-upload-field>
        <h3 v-if="Uploads.length > 0" class="mt-10">
          <icon icon="paperclip" />  Attachments in this reply:
        </h3>
        <div class="mt-2 clearfix" />
        <div class="grid grid-cols-8 gap-2">
          <tw-uploaded-image v-for="upload in Uploads" :key="'upload-item-key-' + upload.id" class="col-span-1" :upload="upload" />
        </div>
      </div>
    </div>
  </tw-card>
</template>

<script>
import axios from 'axios'
import TwCard from '@/components/generic/tw-card.vue'
import TwWysiwyg from '@/components/generic/forms/tw-wysiwyg.vue'
import TwButton from '@/components/generic/tw-button.vue'
import TwUploadField from '@/components/generic/uploads/tw-upload-field.vue'
import TwUploadedImage from '@/components/generic/uploads/tw-uploaded-image.vue'
import { useSupportRequestMessagesStore } from '@/stores/supportRequestMessages.js'

export default {
  name: 'SupportRequestAddMessage',
  components: { TwUploadedImage, TwUploadField, TwButton, TwWysiwyg, TwCard },
  mixins: [],
  props: {
    supportRequest: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      SupportRequestMessageContents: null,
      LoadingSendingSupportRequestMessage: false,
      Uploads: []
    }
  },
  methods: {
    async sendSupportRequestMessage () {
      try {
        this.LoadingSendingSupportRequestMessage = true
        const { data } = await axios.post('/api/v1/support-request-messages', {
          support_request_id: this.supportRequest.id,
          message: this.SupportRequestMessageContents,
          attachments_ids: this.Uploads.map(item => item.id)
        })
        useSupportRequestMessagesStore().itemPatchState(data)
        this.LoadingSendingSupportRequestMessage = false
        this.resetData()
      } catch (e) {
        this.LoadingSendingSupportRequestMessage = false
        console.error(e)
      }
    },
    resetData () {
      this.SupportRequestMessageContents = null
      this.Uploads = []
    },
    uploaded (items) {
      this.Uploads = this.Uploads.concat(items)
    }
  }
}
</script>

<style scoped>

</style>
